import { useEffect, useRef } from "react";

export type FrameBackgroundButtonProps = {
  /** The frame's background as `#rrggbb`, or null when it has none. */
  background: string | null;
  onChange(background: string | null): void;
};

/** Lets a frame's owner colour its background, so nobody has to draw a
 * rectangle over the frame to get one. */
export const FrameBackgroundButton = ({
  background,
  onChange,
}: FrameBackgroundButtonProps) => {
  const input = useRef<HTMLInputElement>(null);
  const latest = useRef(onChange);
  latest.current = onChange;

  // React's onChange fires on every move inside the picker; the native
  // `change` fires once, when a colour is settled on — one scene write.
  useEffect(() => {
    const element = input.current;
    const commit = () => element && latest.current(element.value);
    element?.addEventListener("change", commit);
    return () => element?.removeEventListener("change", commit);
  }, []);

  return (
    <span className="canvaschool-frame-background">
      <label>
        배경색
        <input
          ref={input}
          type="color"
          key={background ?? "none"}
          defaultValue={background ?? "#ffffff"}
        />
      </label>
      {background !== null && (
        <button type="button" onClick={() => onChange(null)}>
          배경 지우기
        </button>
      )}
    </span>
  );
};
